// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__hnpML","button":"Alert_button__NjrUN","icon":"Alert_icon__22avN"};